.button {
  padding: 0;
}
